export function FirstShareIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="14" cy="24" r="5" />
      <circle cx="36" cy="14" r="5" />
      <circle cx="36" cy="34" r="5" />
      <line x1="18" y1="22" x2="32" y2="16" />
      <line x1="18" y1="26" x2="32" y2="32" />
    </svg>
  );
}
